export default __webpack_public_path__ + "static/media/gb.1c2fbca1.svg";